import type { MouseEventHandler } from 'react';

import { ProductCarousel } from 'components/common/ProductCarousel/ProductCarousel';
import useMartyContext from 'hooks/useMartyContext';
import { cn } from 'helpers/classnames';

interface SponsoredBrandsCarouselProps {
  heading: string | null;
  slides: React.ReactNode[];
  overrides?: {
    root?: string;
    item?: string;
    backButton?: string;
    forwardButton?: string;
  };
  forwardButtonOnClick?: MouseEventHandler<HTMLButtonElement>;
}

const SponsoredBrandsCarousel = (props: SponsoredBrandsCarouselProps) => {
  const { heading, slides, overrides, forwardButtonOnClick } = props;
  const { testId } = useMartyContext();

  return (
    <section className="flex flex-col gap-4 sm:lumon:mr-4" data-test-id={testId('sponsoredBrandsCarousel')}>
      <h2 className={cn('text-xl/none font-semibold', 'lumon:heading-m')}>{heading}</h2>
      <ProductCarousel overrides={overrides} options={{ slidesToScroll: 1 }} slides={slides} forwardButtonOnClick={forwardButtonOnClick} />
    </section>
  );
};

export default SponsoredBrandsCarousel;
